<app-grid-layout class="scroll" *ngIf="gridData && showListingPage" [gridData]="gridData" [isChangeDetected]="isChangeDetected" [TableName]="'Admin Access Matrix'" [paginationUrl]="paginationUrl" [selectedRange]="selectedSizeToShowData" [searchText]="searchString" (refreshDataEmmiter)="refreshData()" (showNumberOfRecordsEmmiter)="onSelectSizeData($event)" (deleteDetailEmmiter)="deleteRecords($event)" (deleteMultipleRecordsEmmiter)="deleteMultipleRecord($event)" (searchDataEmitter)="searchData($event)" (exportEmmiter)="exportReport($event)" (emmitPagination)="pageNavigation($event)" (addRecordEmmiter)="addRecord()" (editDetailEmmiter)="editRecord($event)" (detailsEmmiter)="showDatails($event)" (sortAsendingEmmiter)="sortAsending($event)" (sortDesendingEmmiter)="sortDesending($event)" (paginationDataEmmiter)="pageChange($event)"></app-grid-layout>
<div class="container modal fade" [style.display]="showAddPopup? 'block' : 'none' ">
  <div class="modal-dialog">
    <div class="modal-body back1color">
      <div class="modal-content">
        <div class="d-flex p-10 bgcolor">
          <img src="././assets/icon/backArrow.svg" class="cp" (click)="backBtn()" />
          <label (click)="backBtn()" class="font_semibold fs-16 pl-15 mt-5 black_color mb-5 cp">Admin Access Matrix /</label>
          <span class="font_semibold fs-16 pl-15 mt-5 black_color mb-5" [style.color]="subModuleButtonColor">{{isEditModeactive?'Edit':'Add New'}}</span>
        </div>
      </div>
      <div class="pl-20 pt-10">
        <ion-row class="p-0 mb-10">
          <ion-col size-sm="8" size-md="4" size-lg="4" size-xs="8" class="p-0">
            <div class="formLabelRegularfs14 mb-5">
              Employee Name
              <span class="red-cl">&nbsp;*</span>
            </div>
            <ng-select [disabled]="operation == 'Edit'" placeholder="Search" [(ngModel)]="selectedAdminEmployee" (change)="changeGetCompanyDataByCompID()">
              <ng-option [value]="item.id" *ngFor="let item of getAllEmployeeofCompany">{{item.name}}</ng-option>
            </ng-select>
            <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && selectedAdminEmployee == null">Employee Name is required</label>
          </ion-col>

          <ion-col size-sm="8" size-md="4" size-lg="4" size-xs="8" class="p-0 ml-10">
            <div class="formLabelRegularfs14 mb-5 ml-20">
              Empl Salary Hide/Show
              <span class="red-cl">&nbsp;*</span>
            </div>
            <!-- Toggle Switch -->
            <div class="toggle-container mt-10 ml-20">
              <span class="label-left">Hide</span>

              <label class="switch" matTooltip="Hide/Show">
                <input type="checkbox" [(ngModel)]="toggleshowSalaryDetails" />
                <span class="slider round"></span>
              </label>

              <span class="label-right">Show</span>
            </div>
          </ion-col>
        </ion-row>
        <div class="cardBox mb-10 mr-10">
          <label class="font_semibold fs-16 ml-10 mt-5 black_color ">Modules</label>
          <div class="clear10"></div>
          <div class="modal-body">
            <ion-row>
              <ion-col size="12" size-sm="6" size-md="3" *ngFor="let item of acessModules;let i = index">
                <ion-item lines="none" class="mat-checkbox-style">
                  <mat-checkbox slot="start" [disabled]="item.isDisabled" [(ngModel)]="item.isChecked" (change)="onCheckModuleAccess($event,i,item)"></mat-checkbox>
                  <ion-label class="fs-12ForMobileView">{{ item.moduleName }}</ion-label>
                </ion-item>
              </ion-col>
            </ion-row>
          </div>
        </div>
        <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && selectedModuleList.length == 0">Modules are required</label>
        <div class="cardBox mr-10 ">
          <label class="font_semibold fs-16 mt-5 black_color">Access</label>
          <ion-row>
            <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs14 mb-5">
                Location
                <span class="red-cl">&nbsp;*</span>
              </div>
              <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Location'" [settings]="dropdownSettings" [data]="locationListOfCompany" [(ngModel)]="officeLocation" (onSelect)="getBandList()" (onDeSelect)="getBandList()" (onSelectAll)="selectAllLocation($event)" (onDeSelectAll)="onDeSelectAllLocation()"></ng-multiselect-dropdown>
              <!-- <ng-select [closeOnSelect]="false" placeholder="Select" multiple="true" [(ngModel)]="officeLocation"
                (blur)="getEmployeeList()">
                <ng-option [value]="item" *ngFor="let item of locationListOfCompany">{{item}}</ng-option>
              </ng-select> -->
              <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && officeLocation.length == 0">Location is required</label>
            </ion-col>
            <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs14 mb-5">
                Grade
                <span class="red-cl">&nbsp;*</span>
              </div>
              <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Grade'" [settings]="dropdownSettings" [data]="bandListOfCompany" [(ngModel)]="band" (onSelect)="getDepartmentList()" (onDeSelect)="getDepartmentList()" (onSelectAll)="selectAllBand($event)" (onDeSelectAll)="onDeSelectAllBand()"></ng-multiselect-dropdown>
              <!-- <ng-select [closeOnSelect]="false" placeholder="Select" multiple="true" [(ngModel)]="band"
                (blur)="getEmployeeList()">
                <ng-option [value]="item" *ngFor="let item of bandListOfCompany">{{item}}</ng-option>
              </ng-select> -->
              <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && band.length == 0">Grade is required</label>
            </ion-col>
            <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs14 mb-5">
                Department
                <span class="red-cl">&nbsp;*</span>
              </div>
              <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Department'" [settings]="dropdownSettings" [data]="DeptListOfCompany" [(ngModel)]="department" (onSelect)="getDesignationList()" (onDeSelect)="getDesignationList()" (onSelectAll)="selectAllDept($event)" (onDeSelectAll)="onDeSelectAllDept()"></ng-multiselect-dropdown>
              <!-- <ng-select [closeOnSelect]="false" placeholder="Select" multiple="true" [(ngModel)]="department"
                (blur)="getEmployeeList()">
                <ng-option [value]="item" *ngFor="let item of DeptListOfCompany">{{item}}</ng-option>
              </ng-select> -->
              <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && department.length == 0">Department is required</label>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs14 mb-5">
                Designation
                <span class="red-cl">&nbsp;*</span>
              </div>
              <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Designation'" [settings]="dropdownSettings" [data]="DesListOfCompany" [(ngModel)]="designation" (onSelect)="getEmployeeList()" (onDeSelect)="getEmployeeList()" (onSelectAll)="selectAllDeg($event)" (onDeSelectAll)="onDeSelectAllDeg()"></ng-multiselect-dropdown>
              <!-- <ng-select [closeOnSelect]="false" placeholder="Select" multiple="true" [(ngModel)]="designation"
                (blur)="getEmployeeList()">
                <ng-option [value]="item" *ngFor="let item of DesListOfCompany">{{item}}</ng-option>
              </ng-select> -->
              <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && designation.length == 0">Designation is required</label>
            </ion-col>
            <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
              <div class="formLabelRegularfs14 mb-5">
                Employee
                <span class="red-cl">&nbsp;*</span>
              </div>
              <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Employee'" [settings]="dropdownSettings" [data]="employeeList" [(ngModel)]="selectedEmployees" (onSelectAll)="selectAllEmp($event)" (onDeSelectAll)="onDeSelectAllEmp()"></ng-multiselect-dropdown>
              <!-- <ng-select [closeOnSelect]="false" placeholder="Select" [multiple]="true" [(ngModel)]="selectedEmployees"
                (blur)="getEmployeeList11()">
                <ng-option [value]="item.id" *ngFor="let item of employeeList">{{item.name}}</ng-option>
              </ng-select> -->
              <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && selectedEmployees.length == 0">Employee is required</label>
              <!-- <ng-select [closeOnSelect]="false" id="item-select" placeholder="Select" [multiple]="true" [(ngModel)]="selectedEmployees" 
              [items]="employeeList" bindLabel="name" bindValue="id">
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                    <div>{{item.name}}</div>
                </ng-template>
            </ng-select> -->
            </ion-col>
          </ion-row>
        </div>
        <div class="mt-20 text-right">
          <button type="button" (click)="backBtn()" class="back_btn">Cancel</button>
          <button type="button" [style.background-color]="buttonColorName" (click)="onClickSaveAccesMatrix()" class="add_btn ml-10 mb-10 mr-10">Save</button>
        </div>
        <div class="clear100"></div>
        <div class="clear30"></div>
        <div class="clear30"></div>
      </div>
    </div>
  </div>
</div>
